import { Component, OnInit } from '@angular/core';
import { Blog } from 'src/app/_models/blog';
import blogsData from '../../../_models/blogs.json';
import { Router } from '@angular/router';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.scss']
})
export class BlogsComponent implements OnInit {

  header: string = 'News Blogs';
  description: string = 'Learn about our latest news and tap into large knowledge blogs';
  joinChat: boolean = false;
  imagePath = "../../../../assets/images/undraw_blog_post_re_fy5x 1.png";
  hasBtn: boolean = false;
  blogs: Array<Blog>;
  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.blogs = blogsData
  }

  blogDetailsNavigation(id: number) {
    this.router.navigate(['blogs-details/' + id]);
  }

  blogsFilter(type: string) {
    if (type == 'All') {
      this.blogs = blogsData
    }
    if (type == 'News') {
      this.blogs = blogsData
      let res = this.blogs.filter(obj => obj.type == type);
      this.blogs = res;
    }
    if (type == 'Cybersecurity') {
      this.blogs = blogsData
      let res = this.blogs.filter(obj => obj.type == type);
      this.blogs = res;
    }
  }
}
